import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  message = signal<string | null>(null);
  private activeTimer: any = null;

  show(msg: string, duration: number = 4000) {
    // 1. Clear any existing timer so it doesn't kill the NEW message
    if (this.activeTimer) {
      clearTimeout(this.activeTimer);
    }

    // 2. Reset the message to null briefly to restart the CSS animation
    this.message.set(null);

    // 3. Use a tiny delay to allow the DOM to register the removal
    setTimeout(() => {
      this.message.set(msg);

      // 4. Set the new "death timer"
      this.activeTimer = setTimeout(() => {
        this.message.set(null);
        this.activeTimer = null;
      }, duration);
    }, 10);
  }
}
